import type { ReactNode } from "react";
import { cn } from "./cn.js";

type Tone = "neutral" | "success" | "warning" | "danger" | "info" | "brand";

const tones: Record<Tone, string> = {
  neutral: "bg-ink-100 text-ink-700 ring-ink-200",
  success: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  warning: "bg-amber-50 text-amber-700 ring-amber-200",
  danger: "bg-red-50 text-red-700 ring-red-200",
  info: "bg-sky-50 text-sky-700 ring-sky-200",
  brand: "bg-brand-50 text-brand-700 ring-brand-200",
};

export function Badge({
  tone = "neutral",
  children,
  className,
}: {
  tone?: Tone;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset",
        tones[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}

const statusTone: Record<string, Tone> = {
  SUCCESS: "success",
  PAID: "success",
  FULFILLED: "success",
  ACTIVE: "success",
  DELIVERED: "success",
  COMPLETED: "success",
  MATCHED: "success",
  PENDING: "warning",
  PROCESSING: "info",
  AWAITING_PAYMENT: "warning",
  QUEUED: "info",
  RUNNING: "info",
  PARTIALLY_REFUNDED: "warning",
  FAILED: "danger",
  ABANDONED: "neutral",
  SUSPENDED: "danger",
  REFUNDED: "info",
  CANCELLED: "neutral",
  EXHAUSTED: "danger",
  MISMATCH: "danger",
  DEAD: "danger",
};

export function StatusBadge({ status }: { status: string }) {
  return <Badge tone={statusTone[status] ?? "neutral"}>{status.replace(/_/g, " ")}</Badge>;
}
